var exports = {
  "vW": "xdde3148b--614a61--inner",
  "DD": "xdde3148b--614a61--title",
  "zu": "xdde3148b--614a61--values",
  "nM": "xdde3148b--614a61--row",
  "Qq": "xdde3148b--614a61--text",
};

module.exports = exports;
